import React from "react";
import HeroAlternative from "../../components/HeroAlternative/Hero";
import AlternatingImageText from "../../components/AlternatingImageText/AlternatingImageText";
import Contact from "../../components/Contact/Contact";

export default function AgriBusiness() {
  // Data for AlternatingImageText sections
  const customSections = [
    {
      title: "Plantation Establishment",
      bullets: [
        "Land preparation and clearing for rubber and oil palm plantations​",
        "Nursery establishment and management (rubber seedlings and oil palm sprouts)",
        "Planting and field layout according to recommended spacing",
        "Soil testing and site suitability assessments​",
      ],
      imageSrc: "/plantation.jpeg",
      imageAlt: "Project audit analysis and reporting"
    },
    {
      title: "Crop Management and Maintenance",
      bullets: [
        "Tapping system management and latex harvesting​",
        "Tree health monitoring and disease control/three farming system",
        "Application of fertilisers and soil amendments",
        "Weed management and pruning",
        "Latex collection, coagulation, and primary handling Oil Palm",
        "Timely harvesting of ripe Fresh Fruit Bunches",
        "Quality control to minimise free fatty acid (FFA) levels",
        "Transport of FFBs to processing mills",
      ],
      imageSrc: "/fertiliser.jpeg",
      imageAlt: "Team collaboration and change management workshop"
    }
  ];

  return (
    <>
      <HeroAlternative 
        title="Agribusiness"
        description="In line with our project and property management skills we provide support to local farms with the production and processing of agricultural products mainly Rubber and Oil Palm."
        imageSrc="/pexels-cottonbro-7439134.jpg"
        ctaText="Get a Free Consultation"
        ctaLink="/contact"
      />
      
      <AlternatingImageText 
        sections={customSections}
        backgroundColor="light"
      />
      
      <Contact 
        title="Ready to Launch Your Project with Confidence?"
        subtitle="Let's discuss how we can bring clarity and precision to your next initiative. Get a tailored plan for your success."
        ctaText="Schedule a Strategy Call"
      />
    </>
  );
}